module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-foldable"
  }, [_c('div', {
    ref: "container",
    staticClass: "vue-foldable-container",
    style: ({
      maxHeight: _vm.currentMaxHeight + 'px'
    })
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.noMask) ? _c('div', {
    staticClass: "vue-foldable-mask",
    class: {
      'collapsed': _vm.collapsed
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("view-more", [(_vm.reachThreshold) ? _c('div', {
    staticClass: "vue-foldable-view-more",
    class: {
      'collapsed': _vm.collapsed
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('VueIcon', {
    staticClass: "vue-foldable-icon",
    class: {
      'collapsed': _vm.collapsed
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "vue-foldable-text"
  }, [_vm._v("\n        " + _vm._s(_vm.collapsed ? 'View more' : 'Collapse') + "\n      ")])], 1) : _vm._e()], {
    toggle: _vm.toggle,
    collapsed: _vm.collapsed
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c74f0904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/about/foldable/VueFoldable.vue
// module id = 214
// module chunks = 5